import setValue from '../../../modules/setValue';
import caseInsensitiveCompare from '../../../modules/caseInsensitiveCompare';
import nodeListForEach from '../../../modules/nodeListForEach';
require('formdata-polyfill');
const noUiSlider = require('nouislider');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default class {
    constructor(hashFragmentParams, options) {
        this.hashFragmentParams = hashFragmentParams;
        this.firstLoad = true;
        // this.ignoreParams = {};
        this.optionsUrl = '/ajax/new/options';
        this.lastUpdated = '';
        this.data = [];
        this.inputs = {};

        if (typeof options.mobileFormElement != 'undefined') {
            this.mobileFormElement = options.mobileFormElement;
        } else {
            this.mobileFormElement = document.getElementById('new-search-form-mobile');
        }

        if (typeof options.desktopFormElement != 'undefined') {
            this.desktopFormElement = options.desktopFormElement;
        } else {
            this.desktopFormElement = document.getElementById('new-search-form');
        }

        nodeListForEach(document.querySelectorAll('.search-box select'), (index, element) => {
            element.addEventListener('change', event => {
                if (event.target && event.target.dataset.groupName) {
                    this.formUpdated(event.target.dataset.groupName, event.target);
                    return;
                }
                this.formUpdated('', null);
            })
        });
    }

    /**
     * Unticks all checkboxes
     */
    resetForm() {
        Object.keys(this.inputs).forEach(index => {
            // If there's a custom reset function, call it. If the function returns true, then run the rest of the loop, otherwise return
            if (typeof this['reset_' + index] === "function") {
                if (this['reset_' + index]() !== true) {
                    return;
                }
            }

            const elements = document.querySelectorAll("input[name='"+index+"[]']:checked");
            if (!elements) {
                return;
            }
            for (let index = 0, count = elements.length; index < count; index++) {
                elements[index].checked = false;
            }
        });
        this.storeInputs();
        this.formUpdated('', null);
    }

    /**
     * Go over ever input on the form and put it all into an array of values
     */
    storeInputs() {
        let newInputsArray = {};
        const formArea = this.getCurrentForm();
        Object.keys(this.inputs).forEach(key => {
            newInputsArray[key] = [];
            // See if there are <select> for this key, and if there are, store the values
            const selectElements = formArea.querySelectorAll("select[name='"+key+"']");
            const selectElementsLength = selectElements.length;
            if (selectElementsLength > 0) {
                for (let index = 0; index < selectElementsLength; index++) {
                    // Don't add duplicates
                    if (newInputsArray[key].indexOf(selectElements[index].value) >= 0) {
                        continue;
                    }
                    newInputsArray[key].push(selectElements[index].value);
                }
            }

            // See if there are <input type="checkbox"> or <input type="radio"> for this input, and if there are, store the values
            const checkboxes = formArea.querySelectorAll("input[name='"+key+"[]']:checked");
            const checkboxesLength = checkboxes.length;
            if (checkboxesLength > 0) {
                for (let index = 0; index < checkboxesLength; index++) {
                    // Don't add duplicates
                    if (newInputsArray[key].indexOf(checkboxes[index].value) >= 0) {
                        continue;
                    }
                    newInputsArray[key].push(checkboxes[index].value);
                }
            }
        });
        this.inputs = newInputsArray;
    }

    setResponse(data) {
        this.data = data;

        // Check if we have a method named after the key in the data, and if we do, call that method
        Object.keys(data).forEach(key => {
            if (typeof this[key] === "function") {
                this[key]();
            }
        });

        // Since all of the checkboxes get rebuilt, we need to setup the click events again
        $('.search-box input').off('click.newSearchForm').on('click.newSearchForm', event => {
            if (event.target && event.target.dataset.groupName) {
                this.formUpdated(event.target.dataset.groupName, event.target);
                return;
            }
            this.formUpdated('', null);
        });
    }

    /**
     * Rebuild a SELECT element
     * @param {HTMLElement} targetSelectBox The target SELECT element to rebuild
     * @param {string} requestIndex The index in this.data[] to reference e.g. 'model'
     * @param {string} title The title of the drop down, which is used for the first element/placeholder text
     * @param {Function} formatFunction A function that returns the formatted text based on a value e.g. if the value is 2 it might return '2 doors'
     */
    rebuildSelectBox(targetSelectBox, requestIndex, title, formatFunction) {
        if (typeof this.data[requestIndex] === 'undefined') {
            return false;
        }

        const arrayOfNewOptions = this.data[requestIndex];

        let checkPreviousValueIsPresent = false;
        let previousSelectedOption = targetSelectBox[0].options[targetSelectBox[0].selectedIndex];
        let previousSelectedValue, previousSelectedText;

        if (previousSelectedOption) {
            previousSelectedValue = previousSelectedOption.value;
            previousSelectedText = previousSelectedOption.innerHTML;
        }

        targetSelectBox
            .empty()
            .append($('<option/>',  { value: '', text: title }));

        Object.keys(arrayOfNewOptions).forEach(key => {
            const value = arrayOfNewOptions[key];
            const isSelected = (caseInsensitiveCompare(value, this.inputs[requestIndex]));

            if (isSelected) {
                checkPreviousValueIsPresent = true;
            }

            targetSelectBox.append($('<option/>', {
                value: value,
                text: formatFunction(value),
                selected: isSelected,
            }));
        });

        if (!checkPreviousValueIsPresent && previousSelectedOption && previousSelectedValue != '') {
            let options = {
                value: previousSelectedValue,
                text: previousSelectedText,
                selected: true,
            };
            targetSelectBox.append($('<option/>', options));
        }
    }

    /**
     *
     * @param {Element} checkboxArea Target area to replace with checkboxes
     * @param {array} data Data to render as checkboxes
     * @param {string} fieldName Name of the field e.g. stock_clearance
     * @param {function} valueFunction Function that returns the value for the checkbox
     * @param {function} labelFunction Function that returns the HTML for the checkbox label
     */
    rebuildCheckbox(checkboxArea, data, fieldName, valueFunction, labelFunction) {
        let html = '';
        let checked = false;
        let value = '';
        const previousValueArray = this.inputs[fieldName] || [];
        let checkPreviousValuesArePresent = [];
        previousValueArray.forEach(element => {
            if (element == '') {
                return;
            }
            checkPreviousValuesArePresent.push({
                value: element,
                found: false
            });
        });

        let i = 0;
        for (i = 0; i < data.length; i++) {
            value = valueFunction(data[i]);
            checked = false;
            checkPreviousValuesArePresent.forEach((element, index) => {
                if (caseInsensitiveCompare(element.value, value)) {
                    checkPreviousValuesArePresent[index].found = true;
                    checked = true;
                }
            });
            html += `<label for="${fieldName}${i}">
                <input type="checkbox" class="filled-in" data-group-name="${fieldName}" name="${fieldName}[]" id="${fieldName}${i}" value="${value}" ${(checked) ? 'checked' : ''}>
                <span>${labelFunction(data[i])}</span>
            </label>`;
        }

        checkPreviousValuesArePresent.forEach(element => {
            if (!element.found) {
                i++;
                html += `<label for="${fieldName}${i}">
                    <input type="checkbox" class="filled-in" data-group-name="${fieldName}" name="${fieldName}[]" id="${fieldName}${i}" value="${valueFunction(element.value)}" checked>
                    <span>${labelFunction(element.value)}</span>
                </label>`;
            }
        });

        checkboxArea.innerHTML = html;
    }

    /**
     * Get the current form - mobile or desktop
     * @returns HTMLElement
     */
    getCurrentForm() {
        if (window.matchMedia("(max-width: 991px)").matches) {
            return this.mobileFormElement;
        }
        return this.desktopFormElement;
    }

    formData() {
        const formData = new FormData(this.getCurrentForm());
        formData.set('finance', $('#finance-type').val());
        // data.finance = $('#finance-type').val();
        // Remove any empty keys from the data
        // let nonEmptyData = []
        for (let pair of formData.entries()) {
            if (typeof pair[0] !== 'undefined') {
                continue;
            }
            if (typeof pair[1] !== 'undefined') {
                continue;
            }
            if (pair[1] !== '') {
                continue;
            }
            formData.delete(pair[0]);
        };

        return formData;
    }

    /**
     * Handles re-rendering the search options after a field was changed
     * @param {string} whatWasUpdated field that was changed
     * @param {*} eventTarget nullable Object representing the element that was clicked
     */
    formUpdated(whatWasUpdated = 'all', eventTarget = null) {
        return new Promise((resolve, reject) => {
            this.lastUpdated = whatWasUpdated;
            if (typeof this['inputClicked_' + whatWasUpdated] === "function") {
                this['inputClicked_' + whatWasUpdated](eventTarget);
            }

            this.storeInputs();

            // AJAX request to get new search options
            axios({
                method: 'post',
                url: this.optionsUrl,
                data: this.formData(),
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then(response => {

                this.setResponse(response.data);

                // Trigger the hash fragment update after options are loaded
                this.updateUrl();

                // if (typeof response.data.HasError !== 'undefined' && response.data.HasError == true) {
                //     $(this.newVehicles).each((index, vehicle) => {
                //         vehicle.setFinanceData(false, requests[i]);
                //     });
                //     return false;
                // }

                // $.each( response.data.VehicleResults, ( key, value ) => {
                //     this.getVehicleById(value.Id).setFinanceData(value, requests[i]);
                // });
            }).catch(error => {
                console.error(error);
                // $(this.newVehicles).each((index, vehicle) => {
                //     vehicle.setFinanceData(false, requests[i]);
                // });
            });
            // $.ajax({
            //     async: true,
            //     type: "POST",
            //     cache: false,
            //     dataType: 'json',
            //     url: this.optionsUrl,
            //     data: this.formData(),
            //     success: response => {
            //         this.setResponse(response);
            //     },
            //     error: response => {
            //         console.error(response);
            //     }
            // });
        });
    }

    /**
     * Update the hash fragment in the URL to match the current selected options in the search form
     *
     * @param {boolean} forceReload (optional) defaults to false. Triggers paramchange event if true
     */
    updateUrl(forceReload = false) {
        const formData = this.formData();
        let params = {};
        // Convert the name/value pairs into name: value
        for (var pair of formData.entries()) {
        // data.forEach((nameValuePair, index) => {
            if (typeof pair[0] == 'undefined') {
                continue;
            }
            // if (typeof this.ignoreParams[pair[0]] !== 'undefined') {
            //     continue;
            // }
            if (typeof pair[1] == 'undefined') {
                continue;
            }
            if (typeof params[pair[0]] !== 'undefined') {
                params[pair[0]].push(pair[1]);
                continue;
            }

            params[pair[0]] = [pair[1]];
        }

        if (forceReload) {
            this.firstLoad = true;
        }
        const eventTriggered = this.hashFragmentParams.updateParams(params, this.firstLoad);

        if (this.firstLoad) {
            this.firstLoad = false;
        }

        return {
            params: params,
            eventTriggered: eventTriggered
        };
    }

    /**
     * Updates all form elements to match the parameters in the URL. Used on page load to set the initial values
     * @param {object} params
     */
    loadFromParams(params) {
        // let triggerChange = false;
        Object.keys(params).forEach(key => {
            // Step through every checkbox and tick/untick it depending on the current set of params
            const inputs = document.querySelectorAll("input[name='"+key+"[]']");
            if (inputs.length > 0) {
                for (let index = 0, inputsLength = inputs.length; index < inputsLength; index++) {
                    inputs[index].checked = (caseInsensitiveCompare(inputs[index].value, params[key])) ? true : false;
                }
            }

            // Step through every radio and tick/untick it depending on the current set of params
            const radioInputs = document.querySelectorAll("input[name='"+key+"']");
            if (radioInputs.length > 0) {
                for (let index = 0, inputsLength = radioInputs.length; index < inputsLength; index++) {
                    radioInputs[index].checked = (caseInsensitiveCompare(radioInputs[index].value, params[key])) ? true : false;
                }
            }

            // Store the param value as a single value so select elements, text elements and sliders can use it.
            const singleValue = (Array.isArray(params[key])) ? params[key][0] : params[key];

            // Step through the select elements and make sure they're updated too
            const selectElements = document.querySelectorAll("select[name='"+key+"']");
            if (selectElements.length > 0) {
                for (let index = 0, selectElementsLength = selectElements.length; index < selectElementsLength; index++) {
                    setValue(selectElements[index], singleValue, true);
                }
            }

            if (key == 'minPrice') {
                priceSlider.noUiSlider.set([parseInt(singleValue), null]);
                priceMobileSlider.noUiSlider.set([parseInt(singleValue), null]);
            }
            if (key == 'maxPrice') {
                priceSlider.noUiSlider.set([null, parseInt(singleValue)]);
                priceMobileSlider.noUiSlider.set([null, parseInt(singleValue)]);
            }
            if (key == 'finance') {
                try {
                    setValue(document.getElementById('finance-type'), singleValue);
                } catch (error) {
                    // Do nothing
                }
            }
            if (key == 'postcode') {
                let cleanValue = singleValue;
                if (typeof cleanValue == 'string') {
                    cleanValue = cleanValue.replace(/[^0-9a-z\s]/gi, '');
                }
                setCookieValue('new_postcode', cleanValue);
                setValue(document.querySelectorAll("input[name='postcode']"), cleanValue);
            }
            if (key == 'age') {
                setCookieValue('new_age', parseInt(singleValue));
                setValue(document.querySelectorAll("input[name='age']"), singleValue);
            }
            if (key == 'mileage') {
                setClosestMatchForSelects(document.querySelectorAll("select[name='mileage']"), parseInt(singleValue));
            }
            if (key == 'term') {
                setClosestMatchForSelects(document.querySelectorAll("select[name='term']"), parseInt(singleValue));
            }
            if (key == 'deposit') {
                setValue(document.querySelectorAll("input[name='deposit']"), singleValue);
            }
        });

        //
        // if (triggerChange) {
        //     $('#finance-type').trigger("change");
        // }
    }
}